var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoSoCRgb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 235 83",
    style: {
      enableBackground: "new 0 0 235 83"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#007FA3;}\n\t.st1{fill:#AB1368;}\n\t.st2{fill:#DC4633;}\n\t.st3{fill:#6FC7EA;}\n\t.st4{fill:#6D247A;}\n\t.st5{fill:#8DBF2E;}\n\t.st6{fill:#1E3765;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ARTWORK_-_DOTS",
    transform: "translate(385.226040, 15.151320)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_00000134236784172566600880000005953133423151954084_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_00000075843833481419621850000012565892086266511258_",
    transform: "translate(152.014325, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-329.1,7.3c-4.4,0-7.9,3.5-7.9,7.9s3.5,7.9,7.9,7.9s7.8-3.5,7.8-7.9S-324.7,7.3-329.1,7.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-306.9,58.7c-2.4,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4S-304.5,58.7-306.9,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-306.9,47.7c-2.4,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4 C-302.5,49.6-304.5,47.7-306.9,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M-306.9,36.6c-2.4,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4c2.4,0,4.4-2,4.4-4.4 C-302.5,38.6-304.5,36.6-306.9,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-318,58.7c-2.4,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-313.6,60.7-315.5,58.7-318,58.7 L-318,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-318,47.7c-2.4,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-313.6,49.6-315.5,47.6-318,47.7 L-318,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-329.1,58.7c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4C-324.6,60.8-326.6,58.8-329.1,58.7 L-329.1,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-329.1,47.7c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-324.6,49.7-326.6,47.7-329.1,47.7 L-329.1,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-329.1,36.6c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-324.6,38.6-326.6,36.6-329.1,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-340.2,58.7c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S-337.7,58.7-340.2,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-340.2,47.7c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-335.7,49.6-337.7,47.7-340.2,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M-340.2,36.6c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-335.7,38.6-337.7,36.6-340.2,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-351.2,58.7c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4c2.5,0,4.4-2,4.4-4.4S-348.8,58.7-351.2,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-351.2,47.7c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4c2.5,0,4.4-2,4.4-4.4 C-346.8,49.6-348.8,47.7-351.2,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-351.2,36.6c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4c2.5,0,4.4-2,4.4-4.4 C-346.8,38.6-348.8,36.6-351.2,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-351.2,25.5c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4c2.5,0,4.4-2,4.4-4.4S-348.8,25.5-351.2,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-329.1,25.5c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S-326.6,25.5-329.1,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-329.1,4.8c2.4,0,4.4-2,4.4-4.4s-2-4.4-4.4-4.4c-2.4,0-4.4,2-4.4,4.4S-331.5,4.8-329.1,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-329.1-15.2c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S-326.6-15.2-329.1-15.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M-351.2,14.4c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4c2.5,0,4.4-2,4.4-4.4S-348.8,14.4-351.2,14.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-362.3,58.7c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S-359.9,58.7-362.3,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-362.3,47.7c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-357.9,49.6-359.9,47.7-362.3,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-362.3,36.6c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-357.9,38.6-359.9,36.6-362.3,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-380.8,58.7c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S-378.3,58.7-380.8,58.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-373.4,47.7c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-369,49.6-371,47.7-373.4,47.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-373.4,25.5c-2.5,0-4.4,2-4.4,4.4s2,4.4,4.4,4.4s4.4-2,4.4-4.4S-371,25.5-373.4,25.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M-380.8,36.6c-2.5,0-4.4,2-4.4,4.4c0,2.5,2,4.4,4.4,4.4s4.4-2,4.4-4.4C-376.4,38.6-378.3,36.6-380.8,36.6z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000003069743194456249680000013432771866274396587_",
    className: "st6",
    d: "M-372.7,15.3c-0.9-2.5-2-3.6-3.8-3.6 s-2.8,1.1-2.8,3c0,4.1,11.6,4.4,11.6,12.9c0,4.7-3.2,7.7-8.6,7.7c-4.2,0-7.5-2.3-8.9-7.6l5.1-1.1c0.6,3.3,2.5,4.4,4,4.4 c1.8,0,3.2-1.2,3.2-3.2c0-5.1-11.6-5.2-11.6-12.8c0-4.7,2.8-7.6,8.1-7.6c4.6,0,7.4,2.7,8.3,6.6L-372.7,15.3L-372.7,15.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000091724580102727830930000012617773865117147024_",
    className: "st6",
    d: "M-358.8,26.8c0,3,1.3,3.8,3.4,3.8 c2.1,0,3.4-0.8,3.4-3.8V25h5.2v1.1c0,6.7-3.5,9.1-8.6,9.1c-5,0-8.6-2.4-8.6-9.1v-9.7c0-6.7,3.5-9.1,8.6-9.1c5,0,8.6,2.4,8.6,9.1 v0.1h-5.2v-0.7c0-3-1.3-3.8-3.4-3.8c-2.1,0-3.4,0.8-3.4,3.8V26.8L-358.8,26.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000108281419709834927400000010740878168152433284_",
    className: "st6",
    points: "-342.8,34.8 -342.8,7.7 -337.6,7.7  -337.6,18.5 -330.3,18.5 -330.3,7.7 -325.1,7.7 -325.1,34.8 -330.3,34.8 -330.3,23.1 -337.6,23.1 -337.6,34.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000033368477168142334370000014198741583003955885_",
    className: "st6",
    d: "M-321,16.4c0-6.7,3.5-9.1,8.6-9.1 c5,0,8.6,2.4,8.6,9.1v9.7c0,6.7-3.5,9.1-8.6,9.1c-5,0-8.6-2.4-8.6-9.1V16.4L-321,16.4z M-315.8,26.8c0,3,1.3,3.8,3.4,3.8 c2.1,0,3.4-0.8,3.4-3.8v-11c0-3-1.3-3.8-3.4-3.8c-2.1,0-3.4,0.8-3.4,3.8V26.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000037674267188036045380000011854484215561622688_",
    className: "st6",
    d: "M-300.2,16.4c0-6.7,3.5-9.1,8.6-9.1 s8.6,2.4,8.6,9.1v9.7c0,6.7-3.5,9.1-8.6,9.1s-8.6-2.4-8.6-9.1V16.4L-300.2,16.4z M-295,26.8c0,3,1.3,3.8,3.4,3.8 c2.1,0,3.4-0.8,3.4-3.8v-11c0-3-1.3-3.8-3.4-3.8c-2.1,0-3.4,0.8-3.4,3.8V26.8z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000173855951266988033420000015626847674926190259_",
    className: "st6",
    points: "-279.1,34.8 -279.1,7.7 -273.9,7.7  -273.9,30.2 -265.5,30.2 -265.5,34.8 -279.1,34.8  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_00000160909674384806031750000009186740142006693789_",
    className: "st6",
    d: "M-384.6,48.8c0-6.7,3.5-9.1,8.6-9.1 s8.6,2.4,8.6,9.1v9.7c0,6.7-3.5,9.1-8.6,9.1s-8.6-2.4-8.6-9.1V48.8z M-379.4,59.2c0,3,1.3,3.8,3.4,3.8c2.1,0,3.4-0.8,3.4-3.8V48.2 c0-3-1.3-3.8-3.4-3.8c-2.1,0-3.4,0.8-3.4,3.8V59.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000092429602866384923350000004653004390943932606_",
    className: "st6",
    points: "-363.4,67.3 -363.4,40.1  -349.9,40.1 -349.9,44.7 -358.2,44.7 -358.2,50.9 -351.7,50.9 -351.7,55.5 -358.2,55.5 -358.2,67.2 -363.4,67.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000094604210055401261360000007160405547983465612_",
    className: "st6",
    d: "M-334,59.2c0,3,1.3,3.8,3.4,3.8 c2.1,0,3.4-0.8,3.4-3.8v-1.8h5.2v1.1c0,6.7-3.5,9.1-8.6,9.1s-8.6-2.4-8.6-9.1v-9.7c0-6.7,3.5-9.1,8.6-9.1s8.6,2.4,8.6,9.1v0.1 h-5.2v-0.7c0-3-1.3-3.8-3.4-3.8c-2.1,0-3.4,0.8-3.4,3.8V59.2L-334,59.2z"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000123416321667207183090000009865720248007965569_",
    className: "st6",
    points: "-318,67.3 -318,40.1 -312.8,40.1  -312.8,67.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000071526197776837595930000009669769919975592360_",
    className: "st6",
    points: "-292.1,40.1 -292.1,44.7  -298.2,44.7 -298.2,67.2 -303.4,67.2 -303.4,44.7 -309.4,44.7 -309.4,40.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000047020203942460948440000015098305587579958927_",
    className: "st6",
    points: "-288.7,67.3 -288.7,40.1  -283.5,40.1 -283.5,67.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_00000173869871763754201840000011206896906100498099_",
    className: "st6",
    points: "-279,67.3 -279,40.1 -264.8,40.1  -264.8,44.7 -273.9,44.7 -273.9,50.9 -267,50.9 -267,55.5 -273.9,55.5 -273.9,62.7 -264.5,62.7 -264.5,67.2 -279,67.2  "
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_00000132783986430535256740000011166785393761951648_",
    className: "st6",
    d: "M-248.9,47.7c-0.9-2.5-2-3.6-3.8-3.6 c-1.8,0-2.8,1.1-2.8,3c0,4.1,11.6,4.4,11.6,12.9c0,4.7-3.2,7.7-8.6,7.7c-4.2,0-7.5-2.3-8.9-7.6l5.1-1.1c0.6,3.3,2.5,4.4,4,4.4 c1.8,0,3.2-1.2,3.2-3.2c0-5.1-11.6-5.2-11.6-12.8c0-4.7,2.8-7.6,8.1-7.6c4.6,0,7.4,2.7,8.3,6.6L-248.9,47.7L-248.9,47.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoSoCRgb);
export default __webpack_public_path__ + "static/media/LOGO-SoC-RGB.8d30a193a2f3c93f965f8effa6bd8537.svg";
export { ForwardRef as ReactComponent };